import classNames from 'classnames';
import * as React from 'react';

export const Container = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div
    className={classNames({
      'xxs:max-w-695 xs:max-w-695 sm:max-w-810 md:max-w-810 lg:max-w-900 lg1:max-w-1056 mx-auto xxxs:max-w-810':
        true,

      // 'xxs:max-w-640 xs:max-w-640 sm:max-w-752 md:max-w-848 lg:max-w-960 mx-auto xxxs:max-w-768':

      [className || '']: !!className,
    })}
  >
    {children}
  </div>
);
